// extracted by mini-css-extract-plugin
module.exports = {"root":"WatchTypePills_root__l2C6G","pills":"WatchTypePills_pills__tl23q","pill":"WatchTypePills_pill__nRbe7","pillSelected":"WatchTypePills_pillSelected__rvrbP"};